import {combineReducers,configureStore} from "@reduxjs/toolkit";
import appSlice from "./slices/appSlice";
import authSlice from "./slices/auth/authSlice";
import ordersSlice from "./slices/orders/ordersSlice";
import supportsSlice from "./slices/supports/supportsSlice";
import currencyRatesSlice from "./slices/currencyRates/currencyRatesSlice";


const rootReducer = combineReducers({
    app: appSlice,
    auth: authSlice,
    orders: ordersSlice,
    supports: supportsSlice,
    currencyRates: currencyRatesSlice
});

export const store = configureStore({
    reducer: rootReducer
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch